import { defineComponent } from 'vue';
import { QSelect } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const DROPDOWN_LIST_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

const placeholderItems = [
    { Name: 'Option A', Value: 'a' },
    { Name: 'Option B', Value: 'b' },
];

export default defineComponent({
    name: 'dropdown-list-dsgn',
    mixins: [BaseComponentMixin],
    components: { QSelect },
    data() {
        return {
            items: [],
            nameField: 'Name',
            valueField: 'Value',
        };
    },
    mounted() {
        this.Refresh();
    },
    computed: {
        mappedOptions() {
            if (!this.items || !this.items.length)
                return [];
            return this.items.map((item) => ({
                label: this.getName(item),
                value: this.getValue(item),
                _raw: item,
            }));
        },
        /** Static preview selection (first option) for designer appearance */
        previewSelectedOption() {
            const opts = this.mappedOptions;
            return opts.length > 0 ? opts[0] : null;
        },
        selectStyles() {
            return {
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
            };
        },
    },
    methods: {
        async Refresh() {
            if (!this.controlData)
                return;

            if (this.controlData.SourceType == 'URL' || (!this.controlData.SourceType && this.controlData.SourceURL)) {
                try {
                    this.items = await utils.api.get(this.controlData.SourceURL, true);
                }
                catch (e) {
                    this.items = [];
                }
            }
            else if (this.controlData.SourceType == 'Raw' && Array.isArray(this.controlData.Source)) {
                this.items = this.controlData.Source;
            }
            else
                this.items = [];

            if (!this.items.length)
                this.items = [...placeholderItems];

            if (this.controlData.FieldMappings?.AutoSource && this.items.length > 0) {
                const i0 = this.items[0];
                if ('name' in i0) this.nameField = 'name';
                else if ('Name' in i0) this.nameField = 'Name';
                else if ('title' in i0) this.nameField = 'title';
                else if ('Title' in i0) this.nameField = 'Title';
                else {
                    const keys = Object.keys(i0);
                    const idx = keys.findIndex((k) => typeof i0[k] === 'string');
                    this.nameField = idx >= 0 ? keys[idx] : 'name';
                }

                if ('value' in i0) this.valueField = 'value';
                else if ('Value' in i0) this.valueField = 'Value';
                else if ('id' in i0) this.valueField = 'id';
                else if ('Id' in i0) this.valueField = 'Id';
                else if ('ID' in i0) this.valueField = 'ID';
                else {
                    const keys = Object.keys(i0);
                    const idx = keys.findIndex((k) => k != this.nameField);
                    this.valueField = idx >= 0 ? keys[1] : this.nameField;
                }
            }
            else if (this.controlData.FieldMappings) {
                if (typeof this.controlData.FieldMappings.Name === 'string')
                    this.nameField = this.controlData.FieldMappings.Name;
                if (typeof this.controlData.FieldMappings.Value === 'string')
                    this.valueField = this.controlData.FieldMappings.Value;
            }
        },
        getValue(item) {
            if (item == null)
                return null;
            return item[this.valueField];
        },
        getName(item) {
            if (item == null)
                return '';
            return item[this.nameField];
        },
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, DROPDOWN_LIST_CLICK_CODE_BEHIND);
        },
    },
    props: {
    },
    render() {
        if (!this.controlData)
            return null;

        const style = {
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            ...utils.getStyleHints(this.controlData.StyleHints, this),
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            minWidth: '300px',
        };

        const labelText = this.controlData.Label || '';

        return (
            <div
                class={{
                    'designer-container': true,
                    selected: this.selected$,
                    'q-ma-sm': true,
                }}
                style={style}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                <QSelect
                    class={{ 'c-DropdownList': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                    style={this.selectStyles}
                    outlined
                    dense
                    options={this.mappedOptions}
                    optionLabel="label"
                    optionValue="value"
                    emitValue={false}
                    mapOptions
                    label={labelText}
                    modelValue={this.previewSelectedOption}
                    readonly
                />
            </div>
        );
    },
});
